export default {
	init() {},
};
